import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

const registerEventOpenPhoneNumber = (
  eventLocation: string,
) => {
  // GA4
  addDataLayerEntry('contact_phone', {
    location: window.location.href,
    component: eventLocation,
  });

  // GA3
  addEventEntry({
    eventCategory: 'micro_conversions',
    eventAction: 'contact_phone',
    eventLabel: JSON.stringify({ location: window.location.href, component: eventLocation }),
  });
};

export {
  registerEventOpenPhoneNumber,
};
